import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer,SafeHtml} from '@angular/platform-browser';

@Pipe({
    name: 'highlightSearch'
})
export class HighlightSearchPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    // transform(value: string, searchTerm: string) {
    //     if (!searchTerm) {
    //         return this.sanitizer.bypassSecurityTrustHtml(value);
    //     }
    //     const regex = new RegExp(searchTerm, 'gi');
    //     const data = value.match(regex);
    //     let highlightedValue = value;
    //     if (data != null) {
    //         highlightedValue = value.replace(regex, `<span style='background-color:yellow;'>` + data[0] + `</span>`);
    //     }
    //     return this.sanitizer.bypassSecurityTrustHtml(highlightedValue);
    // }
    transform(value: string, searchTerm: string): SafeHtml {
        let sanitizedValue: string = '';

        if (!searchTerm) {
            sanitizedValue = value;
        } else {
            const regex = new RegExp(searchTerm, 'gi');
            const match = value.match(regex);

            if (match) {
                sanitizedValue = value.replace(regex, `<span style='background-color:yellow;'>${match[0]}</span>`);
            } else {
                sanitizedValue = value;
            }
        }

        return this.sanitizer.bypassSecurityTrustHtml(sanitizedValue);
    }
}
